const LEVEL_COLOR = { kritik: "#ef4444", "yüksek": "#f97316", orta: "#f59e0b", "düşük": "#22c55e" };
export const levelColor = (level) => LEVEL_COLOR[level] || "#475569";

export function HeatDefs() {
  return Object.entries(LEVEL_COLOR).map(([level, color]) => (
    <radialGradient key={level} id={`heat-${level}`}>
      <stop offset="0" stopColor={color} stopOpacity="0.85"/>
      <stop offset="0.45" stopColor={color} stopOpacity="0.35"/>
      <stop offset="1" stopColor={color} stopOpacity="0"/>
    </radialGradient>
  ));
}

export function HeatBlobs({ cities, risk }) {
  return risk.map((r) => {
    const c = cities[r.city];
    if (!c) return null;
    return (
      <circle key={r.city} className={`heat-blob ${r.level}`} cx={c.x} cy={c.y} r={22 + r.score * 0.55}
        fill={`url(#heat-${r.level})`} data-testid={`heat-${r.city}`}/>
    );
  });
}

export function RiskRanking({ risk, formula, onSelect }) {
  return (
    <aside className="risk-rank" data-testid="risk-ranking">
      <div className="risk-rank-head"><div className="eyebrow">RİSK SIRALAMASI</div><h3>Şehir bazlı açık bulgu</h3></div>
      {risk.map((r) => (
        <button key={r.city} className="risk-row" onClick={() => onSelect(r.city)} data-testid={`risk-row-${r.city}`}>
          <b>#{r.rank}</b>
          <div className="risk-row-main">
            <strong>{r.name}</strong>
            <div className="risk-bar"><i style={{ width: `${r.score}%`, background: levelColor(r.level) }}/></div>
            <small>{r.open} açık · {r.critical} kritik · {r.assessments} değerlendirme</small>
          </div>
          <span className="risk-score" style={{ color: levelColor(r.level) }}>{r.score}</span>
        </button>
      ))}
      {!risk.length && <div className="risk-empty">Henüz şehirle eşleşen değerlendirme yok.</div>}
      {formula && <div className="risk-formula">{formula}</div>}
    </aside>
  );
}

export function CityRiskStats({ row }) {
  if (!row) return <small className="evidence-empty">Bu şehirde açık bulgu yok.</small>;
  return (
    <div className="city-risk-stats" data-testid="city-risk-stats">
      <div><strong style={{ color: levelColor(row.level) }}>{row.score}</strong><small>Risk skoru · {row.level}</small></div>
      <div><strong>{row.open}</strong><small>Açık bulgu</small></div>
      <div><strong>{row.critical}</strong><small>Kritik</small></div>
      <div><strong>{row.nonconforming}</strong><small>Uygunsuz</small></div>
    </div>
  );
}
